import { track } from '@updater-core/lib/tracker';
import { ITEM_KINDS, STATES } from '../../../../constants';
import { isFeatureEnabled } from '@updater-core/lib/optimizely';
import { actions } from '../../../../state';

const ITEM_KIND = ITEM_KINDS.DIY_MOVE;

// TODO: Dedupe from MoveIQ somehow?
const _isFeatureEnabled = (featureKey) => isFeatureEnabled(featureKey);

export const isInFeatureShowSurvey = () => {
  const override = localStorage.getItem('moveiq-ask-survey');
  if (override) {
    return Promise.resolve(override === 'true');
  }
  return _isFeatureEnabled('MoveIQ_Abandon_Questionnaire').then((result) => {
    localStorage.setItem('moveiq-ask-survey-enabled', result);
    return result;
  });
};

export function DiyMoveConfig($stateProvider) {
  'ngInject';

  $stateProvider.state(STATES.STEP_DIY_MOVE, {
    url: `/diy-move`,
    data: {
      moveItem: {
        type: ITEM_KIND,
        singleton: true,
      },
    },
    disableBreadcrumb: true,
    views: {
      '@': {
        template:
          '<upd-diy-move-v2 class="container micro-app-fixes"></upd-diy-move-v2>',
        controller: (updEnvironment, updStore, $element, $scope) => {
          // Load the Bundle
          const diyMoveAppBundle = import(
            /* webpackChunkName: "diy-move" */ './app'
          );
          diyMoveAppBundle.then(() => {
            const buildApp = buildMicroApp(
              $element.find('upd-diy-move-v2')[0],
              $scope,
              updEnvironment,
              updStore
            );
            buildApp().then(() => {
              const unsubscribe = updStore.subscribe(buildApp);
              $scope.$on('$destroy', unsubscribe);
            });
          });
        },
      },
    },
    scrollTop: true,
    analytics: {
      page: `DIY Move Landing`,
    },
  });
}

const buildMicroApp = (app, $scope, updEnvironment, _updStore) => {
  return async function () {
    const state = _updStore.getState();

    const tracker = {
      track,
    };

    const _shouldSeeSurvey = (payload) => {
      _updStore.dispatch(actions.moveiq.shouldSeeSurvey(payload));
    };

    const _diyConversion = (payload) => {
      _updStore.dispatch(actions.moveiq.diyConversion(payload));
    };

    const updStore = {
      ..._updStore,
      shouldSeeSurvey(bool) {
        if (bool) {
          isInFeatureShowSurvey().then((enabled) => {
            _shouldSeeSurvey(enabled);
          });
        } else {
          _shouldSeeSurvey(bool);
        }
      },
      diyConversion: _diyConversion,
    };

    const { diyConversion } = updStore.getState().moveiq;

    if (diyConversion) {
      _shouldSeeSurvey(false);
    }

    app.props = {
      env: updEnvironment,
      tracker,
      updStore,
      state,
    };
  };
};
